var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { PopupMessageDefaultConfig } from "sb-resp-ui";
import { getPopupShowConfig } from "../getPopupShowConfig";
import { getPopupMessageConfig } from "../getPopupMessageConfig";
export var getPopupConfigs = function (context, config, legacyCallback) {
    var popupShowConfig = {}, popupMessageConfig = __assign({}, PopupMessageDefaultConfig);
    if (config) {
        popupShowConfig = getPopupShowConfig(config, legacyCallback);
        popupMessageConfig = getPopupMessageConfig(config, context);
    }
    return { popupShowConfig: popupShowConfig, popupMessageConfig: popupMessageConfig };
};
//# sourceMappingURL=getPopupConfig.js.map